import { useLocation } from 'react-router-dom';
import { isNewCatalogUser } from '../../utils/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error Could not find a declaration file for module
import personImageUrl from 'bender-url!../../../images/wizard-person.svg';
// @ts-expect-error Could not find a declaration file for module
import useMediaQuery from '../../hooks/useMediaQuery';
import { device } from '../../constants/StyledComponentConstants';
import UsageTracker from '../../utils/UsageTracker';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { WIZARD_URL_FRAGMENT } from '../../constants/Navigation';
import { useWizardProgress } from '../../features/wizard/wizardQueries';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { Flex } from 'foundations-components/components/Flex';
import { BackButton } from 'foundations-components/transitional/components/BackButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { Image } from 'foundations-components/transitional/components/Image';
import I18n from 'I18n';
import { Box } from 'foundations-components/transitional/components/Box';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// Shared button components
const BackButtonComponent = ({
  onClick
}) => /*#__PURE__*/_jsx(BackButton, {
  children: /*#__PURE__*/_jsx(Button, {
    onClick: onClick,
    use: "link",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.wizard.modal.buttons.backlink"
    })
  })
});
const CloseButtonComponent = ({
  onClick
}) => /*#__PURE__*/_jsx(IconButton, {
  "aria-label": I18n.text('learningCenter.common.close'),
  onClick: onClick,
  paddingBlock: "100",
  use: "transparent",
  children: /*#__PURE__*/_jsx(RemoveIcon, {
    color: "icon-core-subtle",
    size: "600"
  })
});
const ResultsLinkComponent = ({
  onClick,
  to,
  totalResultCount
}) => /*#__PURE__*/_jsx(RouterLink, {
  onClick: onClick,
  to: to,
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.wizard.modal.stepfinal.resultslink",
    options: {
      resultsCount: totalResultCount
    }
  })
});
const DesktopHeaderRow = ({
  showBackButton,
  backClick,
  showCloseButton,
  onClickCancel,
  showResultsLink,
  resultsUrl,
  trackCatalogLinkClick,
  totalResultCount
}) => /*#__PURE__*/_jsx(View, {
  marginInline: "auto",
  maxInlineSize: "1700px",
  children: /*#__PURE__*/_jsxs(Flex, {
    alignItems: "start",
    children: [/*#__PURE__*/_jsx(Box, {
      flexShrink: 0,
      inlineSize: "350px",
      children: /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        blockSize: "72px",
        children: showBackButton && /*#__PURE__*/_jsx(BackButtonComponent, {
          onClick: backClick
        })
      })
    }), /*#__PURE__*/_jsx(Box, {
      flexShrink: 0,
      inlineSize: "600"
    }), /*#__PURE__*/_jsx(Box, {
      flex: 1,
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        blockSize: "72px",
        justifyContent: "end",
        children: [showCloseButton && /*#__PURE__*/_jsx(CloseButtonComponent, {
          onClick: onClickCancel
        }), showResultsLink && /*#__PURE__*/_jsx(ResultsLinkComponent, {
          onClick: trackCatalogLinkClick,
          to: resultsUrl,
          totalResultCount: totalResultCount
        })]
      })
    })]
  })
});
const WizardActions = ({
  onBackLinkClick,
  onCancelClick,
  totalResultCount,
  catalogUrl
}) => {
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const location = useLocation();
  const isNewUser = isNewCatalogUser(location.search);
  const trackCatalogLinkClick = () => {
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-click-view-results-on-catalog',
      location: 'results page header'
    });
  };
  const {
    currentStep
  } = useWizardProgress();
  const isFinalStep = currentStep === 'final';
  const showBackButton = location.pathname !== WIZARD_URL_FRAGMENT;
  const showCloseButton = !isNewUser && !isFinalStep;
  const showResultsLink = isFinalStep && totalResultCount > 0;
  if (!isMobile) {
    return /*#__PURE__*/_jsx(View, {
      paddingBlockEnd: "500",
      paddingBlockStart: "500",
      paddingInline: "500",
      children: /*#__PURE__*/_jsx(DesktopHeaderRow, {
        backClick: onBackLinkClick,
        onClickCancel: onCancelClick,
        resultsUrl: catalogUrl,
        showBackButton: showBackButton,
        showCloseButton: showCloseButton,
        showResultsLink: showResultsLink,
        totalResultCount: totalResultCount,
        trackCatalogLinkClick: trackCatalogLinkClick
      })
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    flex: "0 0 58px",
    paddingBlockEnd: "0",
    paddingBlockStart: "500",
    paddingInline: "200",
    children: [/*#__PURE__*/_jsx(Box, {
      grow: 1,
      children: showBackButton ? /*#__PURE__*/_jsx(BackButtonComponent, {
        onClick: onBackLinkClick
      }) : /*#__PURE__*/_jsx(Image, {
        marginBlockEnd: "-200",
        src: personImageUrl,
        width: 44
      })
    }), showCloseButton && /*#__PURE__*/_jsx(CloseButtonComponent, {
      onClick: onCancelClick
    }), showResultsLink && /*#__PURE__*/_jsx(ResultsLinkComponent, {
      onClick: trackCatalogLinkClick,
      to: catalogUrl,
      totalResultCount: totalResultCount
    })]
  });
};
export default WizardActions;